import React from "react";
import { DeclineReasonModal as SharedDeclineReasonModal } from "newui/components/ui/DeclineReasonModal";
import type { DeclineReason } from "../../../../types/clarification-review.type";
import { DECLINE_REASON_LABELS } from "../../../../types/clarification-review.type";

interface DeclineReasonModalProps {
	count: number;
	isLoading: boolean;
	isOpen: boolean;
	onClose: () => void;
	onConfirm: (reason: string, category: DeclineReason) => void;
}

export const DeclineReasonModal: React.FC<DeclineReasonModalProps> = ({
	isOpen,
	count,
	onClose,
	onConfirm,
	isLoading,
}) => {
	return (
		<SharedDeclineReasonModal
			isOpen={isOpen}
			count={count}
			itemLabel="clarification"
			reasons={DECLINE_REASON_LABELS}
			defaultReason="not_relevant"
			onClose={onClose}
			onConfirm={(reason, category) => onConfirm(reason, category as DeclineReason)}
			isLoading={isLoading}
		/>
	);
};
